
import { defineComponent } from "vue";
import BrandingBanner from "@/components/common/BrandingBanner.vue";
import InvoiceControls from "./InvoiceControls.vue";

export default defineComponent({
  components: { InvoiceControls, BrandingBanner },
});
